<div class="generic-modal-root" style="width: 120%;">

  <div class="row-padding">
    <form [formGroup]="form">

      <div class="form-group m-form__group row">
        <app-service-period formControlName="period" [minDays]="0" [showToolTip]="false"></app-service-period>
        <app-validation-display
          [control]="form.controls.period"
          errorMessage="Start date cannot come after end date.">
        </app-validation-display>
      </div>



      <div class="form-group m-form__group row">
        <div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%">
          <input
          style="margin-right: 15px;"
          class="form-control m-input"
          type="time"
          formControlName="startTime"
          id="startTime"
          name="startTime"
          [min]="startMin" 
          [max]="startMax">

          <input
          class="form-control m-input"
          type="time"
          formControlName="endTime"
          id="endTime"
          name="endTime"
          [min]="endMin" 
          [max]="endMax">
        </div>

        <div class="mt-4 d-flex">
          <label class="col-lg-4 col-form-label" > Time Zone </label>
          <div class="col-lg-8" *ngIf="timeZones['us']">
            <select
              class="form-control m-input"
              id="timeZones"
              formControlName="timeZone"
              [compareWith]="compare"
              name="timeZones">
              <option disabled value="0">--- Select Timezone ---</option>
              <option *ngFor="let z of timeZones['us']" [ngValue]="z.Id">
                {{z.DisplayName}}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="form-group m-form__group row">
        <label class="col-lg-4 col-form-label"> Enable Unique Devices </label>
        <div class="col-lg-8" style="align-self: center; display: flex; justify-content: center;">
          <label class="switch">
            <input formControlName="uniqueDevices" type="checkbox" name="i" style="padding-top: 7px;">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="form-group m-form__group row">
        <label class="col-lg-4 col-form-label"> Enable Triggered Devices </label>
        <div class="col-lg-8" style="align-self: center; display: flex; justify-content: center;">
          <label class="switch">
            <input formControlName="triggeredDevices" type="checkbox" name="i" style="padding-top: 7px;">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="form-group m-form__group row">
        <label class="col-lg-4 col-form-label"> Enable Misfired Devices </label>
        <div class="col-lg-8" style="align-self: center; display: flex; justify-content: center;">
          <label class="switch">
            <input formControlName="misfiredDevices" type="checkbox" name="i" style="padding-top: 7px;">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="form-group m-form__group row">
        <label class="col-lg-4 col-form-label"> Enable Total Triggers </label>
        <div class="col-lg-8" style="align-self: center; display: flex; justify-content: center;">
          <label class="switch">
            <input formControlName="totalTriggers" type="checkbox" name="i" style="padding-top: 7px;">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="form-group m-form__group row">
        <label class="col-lg-4 col-form-label"> Enable Triggers Heard </label>
        <div class="col-lg-8" style="align-self: center; display: flex; justify-content: center;">
          <label class="switch">
            <input formControlName="triggersHeard" type="checkbox" name="i" style="padding-top: 7px;">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="form-group m-form__group row">
        <label class="col-lg-4 col-form-label"> Enable Successful Triggers </label>
        <div class="col-lg-8" style="align-self: center; display: flex; justify-content: center;">
          <label class="switch">
            <input formControlName="successfulTriggers" type="checkbox" name="i" style="padding-top: 7px;">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="form-group m-form__group row">
        <label class="col-lg-4 col-form-label"> Enable Misfires </label>
        <div class="col-lg-8" style="align-self: center; display: flex; justify-content: center;">
          <label class="switch">
            <input formControlName="misfires" type="checkbox" name="i" style="padding-top: 7px;">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="form-group m-form__group row">
        <label class="col-lg-4 col-form-label"> Enable Device Trigger Success Rate </label>
        <div class="col-lg-8" style="align-self: center; display: flex; justify-content: center;">
          <label class="switch">
            <input formControlName="deviceTriggerSuccessRate" type="checkbox" name="i" style="padding-top: 7px;">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="form-group m-form__group row">
        <label class="col-lg-4 col-form-label"> Enable Total Engine Auths </label>
        <div class="col-lg-8" style="align-self: center; display: flex; justify-content: center;">
          <label class="switch">
            <input formControlName="totalEngineAuths" type="checkbox" name="i" style="padding-top: 7px;">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="form-group m-form__group row">
        <label class="col-lg-4 col-form-label"> Enable Unique Engine Auths </label>
        <div class="col-lg-8" style="align-self: center; display: flex; justify-content: center;">
          <label class="switch">
            <input formControlName="uniqueEngineAuths" type="checkbox" name="i" style="padding-top: 7px;">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </form>

    <div class="row" style="margin: 0;">

      <div style="display: flex; width:100%; flex-direction: row; justify-content: space-between;">
        <button (click)="close()" class="btn btn-success" style="margin-top:50px;">Close</button>
        <button (click)="generateReport()" class="btn btn-info" style="margin-top:50px;">Generate Report</button>
      </div>


    </div>
    </div>
  </div>

